import {EDragData} from 'webapp-lib/typings';

import {EListEntryDragParams, EListItemEntry} from './types';

export const handleDragStart = <T extends object>({
  dragEvent,
  activeEntry,
  entries,
  selectedEntryIds,
}: EListEntryDragParams<T> & {
  entries: EListItemEntry<T>[];
  selectedEntryIds: Set<string>;
}): void => {
  const draggedRow = dragEvent.currentTarget;
  if (
    !activeEntry ||
    !draggedRow.draggable ||
    !activeEntry.options ||
    (!activeEntry.options.dragDataList && !activeEntry.options.onDragStart)
  ) {
    return;
  }

  const rowsToDrag = new Set([activeEntry.id, ...selectedEntryIds.values()]);

  const dragDataList = [...rowsToDrag].reduce<EDragData[]>(
    (accumulatedValue, id) => {
      const row = entries.find((r) => r.id === id);
      const dataList = row?.options?.dragDataList;
      return dataList ? [...accumulatedValue, ...dataList] : accumulatedValue;
    },
    []
  );

  if (!activeEntry.options.disableDragStyle) {
    draggedRow.classList.add('styleDragged');
  }

  dragDataList.forEach(({format, data: dragData}) => {
    const currentDragData = dragEvent.dataTransfer.getData(format);
    const separator = currentDragData.length === 0 ? '' : ',';
    const updateDragData = currentDragData.concat(separator, dragData);
    dragEvent.dataTransfer.setData(format, updateDragData);
  });

  dragEvent.dataTransfer.dropEffect = 'move';
  activeEntry.options.onDragStart?.(dragEvent);
};

export const handleDragEnd = <T extends object>({
  dragEvent,
}: EListEntryDragParams<T>): void => {
  const draggedRow = dragEvent.target as HTMLTableRowElement;
  draggedRow.classList.remove('styleDragged');
};
